export enum SocialNetworkRoleType {
  ADMIN = 'ADMIN',
  MEMBER = 'MEMBER',
  GUEST = 'GUEST',
  OWNER = 'OWNER',
}
